
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airtable-backup",
      function () {
        return require("private-next-pages/airtable-backup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airtable-backup"])
      });
    }
  